import React from "react";
import { NavLink} from "react-router-dom";

function Nav({title,href,click, classes }) {
  const inActive = `${classes} border-none cursor-pointer text-[2rem] uppercase no-underline font-bold mr-4 sm:mr-8`;
  const active = `${inActive} font-extrabold`;
  return (
    <NavLink
      to={href}
      onClick={click}
      className={({ isActive }) => (isActive ? `${active} ` : inActive)}
    >
      {title}
    </NavLink>
  );
}

export default Nav;
